{
  "name": "geckoboard",
  "version": "2.0.2",
  "description": "",
  "main": "dist/index.js",
  "scripts": {
    "build": "tsup",
    "test": "jest",
    "lint": "eslint src --ext .ts"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/geckoboard/geckoboard-node.git"
  },
  "keywords": [
    "geckoboard",
    "node",
    "javascript"
  ],
  "author": "",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/geckoboard/geckoboard-node/issues"
  },
  "homepage": "https://developer.geckoboard.com/",
  "devDependencies": {
    "@types/jest": "^29.5.8",
    "@typescript-eslint/eslint-plugin": "^6.10.0",
    "@typescript-eslint/parser": "^6.10.0",
    "eslint": "^8.53.0",
    "eslint-config-prettier": "^9.0.0",
    "eslint-plugin-prettier": "^5.0.1",
    "jest": "^29.7.0",
    "prettier": "3.1.0",
    "ts-jest": "^29.1.1",
    "ts-node": "^10.9.1",
    "tsup": "^7.2.0",
    "typescript": "^5.2.2"
  },
  "dependencies": {
    "undici": "^6.24.0"
  }
}
